module.exports = __webpack_public_path__ + "img/thumbnail_Aardvark_f_normal.54224aa4.png";